module.exports = __webpack_public_path__ + "static/media/icon_kuaisujieru.8400a659.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_kuaisujieru.svg
// module id = 121
// module chunks = 0